export type Palette =
	| 'primary'
	| 'secondary'
	| 'neutral'
	| 'error'
	| 'social'
	| 'positive'
	| 'warning'

export type Shade = 25 | 50 | 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900 | 950

export class ColorPalette {
	private static colorCache: Record<string, string> = {}

	static getColor(palette: Palette, shade: Shade): string {
		const colorVar = `--color-${palette}-${shade}`
		if (this.colorCache[colorVar]) return this.colorCache[colorVar]

		const value = getComputedStyle(document.documentElement).getPropertyValue(colorVar).trim()
		this.colorCache[colorVar] = value

		return value || '#ff0000'
	}
}
